import {
  Flex,
  Heading,
  Text,
  Button,
  Box,
  useColorModeValue,
  useDisclosure,
} from '@chakra-ui/react';
import { useState } from 'react';
import { FaVideo } from 'react-icons/fa';
import Page from '../../layout/IntegraAppPage';
import CriarLive from '../../components/Modals/LiveModal/CriarLive';

const LiveCommerce = () => {
  const [ativo, setAtivo] = useState('Todas');

  const borderColor = useColorModeValue('gray.200', 'gray.700');
  const textColor = useColorModeValue('gray.600', 'gray.300');
  const activeColor = useColorModeValue('blue.500', 'blue.300');
  const bgCard = useColorModeValue('white', 'gray.800');

  const tabs = ['Todas', 'Ao vivo', 'Agendadas', 'Finalizadas'];

  const modalControle = useDisclosure();
  return (
    <Page>
      <Flex>
        <Heading fontSize="25px" mt={1} mb={4} ml="18px">
          LiveCommerce
        </Heading>
      </Flex>

      <Flex>
        <Text fontSize="15px" color="gray.500" ml="18px">
          Gerencie suas transmissões ao vivo de rendas
        </Text>

        <Button colorScheme="red" ml="auto" onClick={modalControle.onOpen}>
          + Nova Live
        </Button>
      </Flex>

      <Flex px={3} borderBottom="1px solid" borderColor={borderColor} gap={6}>
        {tabs.map(tab => {
          const isActive = ativo === tab;
          return (
            <Flex
              key={tab}
              direction="column"
              cursor="pointer"
              pb={2}
              onClick={() => setAtivo(tab)}
            >
              <Text
                fontWeight="medium"
                color={isActive ? activeColor : textColor}
                w="150%"
                ml="18px"
              >
                {tab}
              </Text>

              <Box
                mt={1}
                h="1px"
                ml="18px"
                bg={isActive ? activeColor : 'transparent'}
                borderRadius="full"
                align="center"
              />
            </Flex>
          );
        })}
      </Flex>

      {/* CARD */}
      <Box
        m={3}
        border="1px solid"
        borderColor={borderColor}
        borderRadius="lg"
        bg={bgCard}
        p={6}
      >
        <Flex
          h="300px"
          align="center"
          justify="center"
          direction="column"
          textAlign="center"
        >
          <FaVideo size={40} color="gray" />

          <Text
            mt={4}
            fontWeight="bold"
            color={useColorModeValue('gray.800', 'gray.500')}
          >
            Nenhuma live criada
          </Text>

          <Text fontSize="sm" color="gray.500">
            Comece criando sua primeira transmissão ao vivo de vendas
          </Text>

          <Button mt={4} colorScheme="red" onClick={modalControle.onOpen}>
            + Criar Live
          </Button>
        </Flex>
      </Box>
      {/* Modais */}
      <CriarLive
        isOpen={modalControle.isOpen}
        onClose={modalControle.onClose}
        data={CriarLive}
      />
    </Page>
  );
};

export default LiveCommerce;
